export const CollapsibleTestInformation = [
    // Header section
    { span: 7, height: "32px", classes: "marginTop-8" }, // Main header

    // Questions container - flat structure
    { span: 15, height: "35px", classes: "marginTop-16" }, // First accordion header
    { span: 15, height: "85px", classes: "marginTop-8" }, // First accordion content

    { span: 15, height: "35px", classes: "marginTop-16" }, // Second accordion header
    { span: 15, height: "85px", classes: "marginTop-8" }, // Second accordion content
]
